module.exports = __webpack_public_path__ + "static/media/1280px-Logo_Asklepios_Kliniken_Hamburg.svg.4f3fedce.png";